exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-button--text[data-v-7c912bc9]{font-weight:600}.timelineitem[data-v-7c912bc9]{margin-bottom:-8px}.el-timeline-item[data-v-7c912bc9]{padding-bottom:8px !important}.ellipsis[data-v-7c912bc9]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);

// exports
